import { render } from "./TbHeader.vue?vue&type=template&id=7354c478&scoped=true"
import script from "./TbHeader.vue?vue&type=script&lang=js"
export * from "./TbHeader.vue?vue&type=script&lang=js"

import "./TbHeader.vue?vue&type=style&index=0&id=7354c478&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7354c478"]])

export default __exports__